import { PayloadAction, createSlice, current } from "@reduxjs/toolkit";
import type { IFavourites } from "../../models";
import { logout } from "../../features/auth";
import { getItemWebStorage } from "../../features/webStorageSaver";

function getInitialState(){
    const initialState: IFavourites = {
        lists: getItemWebStorage("favourites") ?? [],
        addToFavouriteModalIsShown: false,
        expandedKeys: {},
        favouriteDeleted: false
    }
    return initialState
}

export const favouritesSlice = createSlice({
    name: 'favourites',
    initialState: getInitialState(),
    reducers: {
        changeFavouritesList(state, action: PayloadAction<any>) {
            state.lists = action.payload
        },
        addFavouriteList(state, action: PayloadAction<string>) {
            state.lists.push({ name: action.payload, roadDirections: [] })
        },
        deleteFavouriteList(state, action: PayloadAction<any>) {
            const listIndex = state.lists.findIndex((item: any) => item.name === action.payload.name)
            state.lists.splice(listIndex, 1)
            state.favouriteDeleted = action.payload.favouriteDeleted
        },
        addRoadDirectionToList(state, action: PayloadAction<any>) {
            state.lists.find((list: any) => list.name === action.payload.listName).roadDirections.push(action.payload.roadDirection)
        },
        addTypeToRoadDirection(state, action: PayloadAction<any>) {
            state.lists.find((list: any) => list.name === action.payload.listName).roadDirections.find((roadDirection: any) => roadDirection.name === action.payload.roadDirectionName).types.push(action.payload.type)
        },
        addValueToType(state, action: PayloadAction<any>) {
            state.lists.find((list: any) => list.name === action.payload.listName).roadDirections.find((roadDirection: any) => roadDirection.name === action.payload.roadDirectionName).types.find(
                (type: any) => type.name === action.payload.type).items.push(action.payload.item)
        },
        deleteValueFromList(state, action: PayloadAction<any>) {
            const items = current(state).lists.find((list: any) => list.name === action.payload.listName).roadDirections.find((roadDirection: any) => roadDirection.name === action.payload.roadDirectionName).types.find(
                (type: any) => type.name === action.payload.type).items;
            state.lists.find((list: any) => list.name === action.payload.listName).roadDirections.find((roadDirection: any) => roadDirection.name === action.payload.roadDirectionName).types.find(
                (type: any) => type.name === action.payload.type).items.splice(items.findIndex((item: any) => item.id == action.payload.id), 1);
            state.favouriteDeleted = action.payload.favouriteDeleted
        },
        deleteTypeFromList(state, action: PayloadAction<any>) {
            const types = current(state).lists.find((list: any) => list.name === action.payload.listName).roadDirections.find((roadDirection: any) => roadDirection.name === action.payload.roadDirectionName).types
            state.lists.find((list: any) => list.name === action.payload.listName).roadDirections.find((roadDirection: any) => roadDirection.name === action.payload.roadDirectionName).types.splice(
                types.findIndex((type: any) => type.name == action.payload.type), 1);
            state.favouriteDeleted = action.payload.favouriteDeleted
        },
        deleteRoadFromList(state, action: PayloadAction<any>) {
            const roads = current(state).lists.find((list: any) => list.name === action.payload.listName).roadDirections
            state.lists.find((list: any) => list.name === action.payload.listName).roadDirections.splice(roads.findIndex((road: any) => road.name == action.payload.roadDirectionName), 1);
            state.favouriteDeleted = action.payload.favouriteDeleted
        },
        setAddToFavouriteModalIsShown(state, action: PayloadAction<boolean>) {
            state.addToFavouriteModalIsShown = action.payload
        },
        setExpandedFavouriteKeys(state, action: PayloadAction<any>) {
            state.expandedKeys = action.payload
        }
    },
    extraReducers: (builder) => {
        builder.addCase(logout, () => {
            return getInitialState()
        })
    },
})

export const { addTypeToRoadDirection,
    addRoadDirectionToList,
    setAddToFavouriteModalIsShown,
    addFavouriteList,
    addValueToType,
    deleteValueFromList,
    deleteRoadFromList,
    deleteTypeFromList,
    changeFavouritesList,
    setExpandedFavouriteKeys,
    deleteFavouriteList
} = favouritesSlice.actions
export const favouritesReducer = favouritesSlice.reducer;
